import React, { Fragment, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { customFilterOperations } from '../../redux/customFilter';
import { userOperations } from '../../redux/user';
import { filterOperations } from '../../redux/filter';
import { incidentsOperations } from '../../redux/incidentList';
import RaisedButton from 'material-ui/RaisedButton';
import Button from '@material-ui/core/Button';
import CustomFiltersDialog from './CustomFiltersDialog';
import CircularProgress from 'material-ui/CircularProgress';
import DifferenceIcon from '@mui/icons-material/Difference';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ListItemIcon from '@mui/material/ListItemIcon';
import Tooltip from '@material-ui/core/Tooltip';
import { buildFilter } from './utils/sqlUtils';
import ShareFilterDialog from './ShareFilterDialog';
import { setCustomFilterDefinitionExpression, setSpatialFilterPolygon, zoomToPolygon } from '../esri/mapHub';
import { v4 as uuidv4 } from 'uuid';

class CustomFiltersList extends Component {

  constructor(props) {
    super(props);
    this.state =
    {
      showingCustomFilterDialog: false,
      optionsMenuIsOpen: false,
      filterForEdit: null,
      filterIsLoading: false,
      filterForEditId: null,
      idx: null,
      showingShareFilterDialog: false
    };
  }

  launchCustomFilters = (event) => {
    event.preventDefault();

    this.setState({
      showingCustomFilterDialog: true
    });
  };

  customFiltersClose = () => {
    this.setState({
      showingCustomFilterDialog: false,
      filterForEdit: null
    });
  }

  handleMenuClose = () => {
    this.setState({
      optionsMenuIsOpen: false
    });
  }

  editFilter = () => {
    const item = this.props.user.customFilters[this.state.idx];

    this.setState({
      showingCustomFilterDialog: true,
      filterForEdit: item,
      filterForEditId: item.CustomFilterID
    });
  }

  duplicateFilter = () => {
    const item = this.props.user.customFilters[this.state.idx];
    const clonedItem = JSON.parse(JSON.stringify(item));
    clonedItem.filterGuid = uuidv4();
    clonedItem.Title = "Copy of " + clonedItem.Title;

    this.setState({
      showingCustomFilterDialog: true,
      filterForEdit: clonedItem,
      filterForEditId: null
    });
  }

  deleteFilter = () => {
    const item = this.props.user.customFilters[this.state.idx];
    window.api.deleteCustomFilter(item.CustomFilterID).then(response => {
      this.props.setCustomFilters(response);
    });
  }

  shareFilter = () => {
    const item = this.props.user.customFilters[this.state.idx];

    this.setState({
      showingShareFilterDialog: true,
      filterForEdit: item
    });
  }

  shareFilterClose = () => {
    this.setState({
      showingShareFilterDialog: false
    });
  }

  setGeometryFromShapefile = (polygon) => 
    { 
      this.props.setHasSpatialFilter(true);
      setSpatialFilterPolygon(polygon);
      zoomToPolygon(polygon);
    }


  filterListItemClicked = (idx) => {
    const item = this.props.user.customFilters[idx];
    const filterContent = JSON.parse(item.FilterContent);
    let activeDefinitionExpression = buildFilter(filterContent);
    this.props.setActiveCustomFilter(filterContent, activeDefinitionExpression);
    this.setState({
      filterIsLoading: true
    });

    this.props.setFilterLoading(true);

    setCustomFilterDefinitionExpression(activeDefinitionExpression).then(response => {
      this.props.setQueriedIncidentsTotal(response.total);
      this.props.setDisplayedIncidentsCount(response.features.length);
      this.props.setIncidents(response.features);
      this.props.setVisibleIncidents(response.features);
      this.props.setFilterLoading(false);
      this.setState({
        filterIsLoading: false
      });
    });
  }

  render() {

    let filterHeaderContent;

    const currentDisplayed = this.props.incidentList.displayedIncidentsCount;
    const queryTotal = this.props.incidentList.queriedIncidentsTotal;
    const labelText = (queryTotal === currentDisplayed) ? 'Showing All ' + currentDisplayed + ' Incidents' : ' Showing ' + currentDisplayed + ' of ' + queryTotal + ' Incidents';

    if (this.props.filter.loading) {
      filterHeaderContent =
        (
          <div style={{ textAlign: "center", marginTop: "22px" }}><CircularProgress size={24} thickness={2} /></div>
        )
    }
    else {
      filterHeaderContent =
        (
          <div style={{ textAlign: "center", marginTop: "22px" }}>{labelText}</div>
        )
    }

    return (
      <Fragment>
        {filterHeaderContent}
        <Table size="small">
          <TableBody>
            {
              this.props.user.customFilters.map((item, idx) => {
                const filterContent = JSON.parse(item.FilterContent);
                const showHighlighted = (this.props.user.activeCustomFilterState && (filterContent.filterGuid === this.props.user.activeCustomFilterState.filterGuid));
                //
                return (
                  <TableRow key={idx}>
                    <TableCell>
                      <Button
                        color="primary"
                        variant={(showHighlighted) ? "contained" : "text"}
                        onClick={e => {
                          this.filterListItemClicked(idx);
                          this.setState({
                            idx: idx
                          });
                        }}>{item.Title}</Button>
                    </TableCell>

                    <TableCell align="right">
                      <Tooltip title="Options" placement="top-start">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small" onClick={(e) => {
                            this.setState({
                              optionsMenuIsOpen: true,
                              anchorEl: e.currentTarget,
                              idx: idx
                            });

                          }}>
                          <MoreVertIcon
                            className="filter-item-header-clear"
                            style={{ width: "20px", height: "20px", paddingTop: "8px" }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
        <Menu open={this.state.optionsMenuIsOpen} anchorEl={this.state.anchorEl} onClose={this.handleMenuClose}>
          <MenuItem onClick={(e) => {
            this.editFilter();
            this.setState({
              optionsMenuIsOpen: false
            });
          }}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            Edit
          </MenuItem>
          <MenuItem onClick={(e) => {
            this.duplicateFilter();
            this.setState({
              optionsMenuIsOpen: false
            });
          }}>
            <ListItemIcon>
              <DifferenceIcon fontSize="small" />
            </ListItemIcon>
            Copy
          </MenuItem>
          <MenuItem onClick={(e) => {
            this.deleteFilter();
            this.setState({
              optionsMenuIsOpen: false
            });
          }}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            Delete
          </MenuItem>
          <MenuItem onClick={(e) => { 
             this.setState({
              optionsMenuIsOpen: false
            });
            this.shareFilter(); }}>
            <ListItemIcon>
              <ShareIcon fontSize="small" />
            </ListItemIcon>
            Share
          </MenuItem>
        </Menu>
        <RaisedButton
          color="primary"
          style={{ marginTop: "10px", marginLeft: "15px" }}
          onClick={this.launchCustomFilters}
          label="Add Custom Filter" />

        <CustomFiltersDialog
          open={this.state.showingCustomFilterDialog}
          onClose={this.customFiltersClose}
          filterForEdit={this.state.filterForEdit}
          setGeometry={this.setGeometryFromShapefile}
          filterForEditId={(this.state.filterForEdit) ? this.state.filterForEditId : null}
          filterTitle={(this.state.filterForEdit) ? this.state.filterForEdit.Title : ''}
        />
        <ShareFilterDialog open={this.state.showingShareFilterDialog}
          onClose={this.shareFilterClose}
          filterForShare={this.state.filterForEdit}
        />
      </Fragment>

    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  incidentList: state.incidentList,
  filter: state.filter
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...userOperations,
    ...incidentsOperations,
    ...filterOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomFiltersList)
